/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import Head from 'next/head';
import { forwardRef } from 'react';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { SearchLayout } from 'v4/snippets/search/layout';
import { SearchPeople } from 'v4/snippets/search/people';
export default forwardRef(({ ...props }, ref) => {
  const { t } = useTranslator();
  return (
    <>
    <AuthenticatedProviders>
      <SearchLayout activeTab={'people'}>
        <Head>
          <title>{t('otherPage.connectWithpeople') || "Connect with People | Create & Search Profiles"}</title>
          <meta
            name="og:title"
            content="Connect with People | Create & Search Profiles"
          />
          <meta
            name="description"
            content="Explore, create, and search profiles on mybridge, a dynamic platform. Connect with people who share your passions. Join us for a joyful social experience!"
          />
          <meta
            name="og:description"
            content="Explore, create, and search profiles on mybridge, a dynamic platform. Connect with people who share your passions. Join us for a joyful social experience!"
          />
        </Head>
        <SearchPeople />
      </SearchLayout>
      </AuthenticatedProviders>
    </>
  );
});
